// extracted by mini-css-extract-plugin
module.exports = {"lineClamp":"style__lineClamp__8HWBs"};